import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { API_BASE_URL, APIs, SERVICEURL } from '../../../constants/Constants';
import { t } from "i18next";
import ProgressBarContext from '../../../context/progressbar/ProgressBarContext';
import themeContext from '../../../context/theme/ThemeContext';

const ProgressBar = (props) => {
    const [progress, setProgress] = useState('0');
    const [progressMessage, setProgressMessage] = useState("");
    const [progressObj, setProgressObj] = useState({
        progress: 0,
        progressMessage: ""
    })
    const [isError, setIsError] = useState(false);
    const [showProgressBar, setShowProgressBar] = useState(false);
    const {progressObjs, setProgressObjs} = useContext(ProgressBarContext);
    const { getThemeColor,getAlterColor } = useContext(themeContext);
    const MainDiv = {
        display:'flex',
        flexDirection:'column',
        width:"100%",
    }

	const Parentdiv = {
		height: props.height,
		width: '30%',
		backgroundColor: getAlterColor("whitesmoke","#c3c3c3"),
		borderRadius: 40,
        marginTop:'7px',
	}
	
	const Childdiv = {
		height: '100%',
		width: `${progressObj.progress}%`,
		backgroundColor: 'rgb(0, 120, 212)',
	    borderRadius:40,
		textAlign: 'right',
        display:'flex',
        flexDirection:'column',
	}
	
	const progresstext = {
		// padding: 10,
		color: 'black',
		fontWeight: 'normal'
	}

    const fileNameStyle = {
        color:getThemeColor("primary-color"),
        fontSize: '13px',
        marginLeft:'14px',
        padding:'0px',
        width: "70%"
    }

    const updateProgressMessage = (msg) => {
        let messageSpan = document.getElementById("progressMessage");
        messageSpan.innerText = msg;
    }
    const updateProgressBar = (percent) => {
        let messageSpan = document.getElementById("progressPercent");
        messageSpan.style.width = percent + "%";
    }


    const studyUploadProcessStatus = async(processId, interval) =>{
        axios.post(API_BASE_URL + SERVICEURL + APIs.FETCHUPLOADPROCESSSTATUS + processId,{})
        .then((res)=>{
            console.log(res);
            let status = res.data.data.status;
            let message = res.data.data.message;            
            switch (status) {
                case 'STUDY_UPLOAD_PROCESS_CREATED':
                    // setProgress(60);
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 60;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 60);
                    break;
                case 'STUDY_UPLOAD_PROCESS_STARTED':
                    // setProgress(80);
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 80;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 80);
                    break;
                case 'SUTDY_UPLOAD_PROCESS_DONE':
                    // setProgress(100);
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 100;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 100);
                    clearInterval(interval);
                    break;
                case 'STUDY_UPLOAD_PROCESS_FAILED':
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 0;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 0);
                    setIsError(true);
                    clearInterval(interval);
                    break;
                case 'STUDY_UPLOAD_PROCESS_FAILED_QUOTA_OVER':
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 0;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 0);
                    setIsError(true);
                    clearInterval(interval);
                    break;
                case 'STUDY_UPLOAD_PROCESS_INVALID_DICOM':
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 0;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 0);
                    setIsError(true);
                    clearInterval(interval);
                    break;
                case 'STUDY_UPLOAD_PROCESS_DCM_PROCESS_FAILED':
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 0;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 0);
                    setIsError(true);
                    clearInterval(interval);
                    break;
                case 'STUDY_UPLOAD_PROCESS_ID_NOT_FOUND':
                    // setProgressMessage(message);
                    // setProgressObj(()=>{
                    //     const newItem = {...progressObj};
                    //     newItem.progress = 0;
                    //     newItem.progressMessage = message;
                    //     return newItem;
                    // });
                    updateProgressBarObjs(message, 0);
                    setIsError(true);
                    clearInterval(interval);
                    break;
            }
            return;
        })
      }

    const uploadDicomApi = async() =>{
        const response = axios.post(API_BASE_URL + SERVICEURL + "/upload/dicom", props.formData, {
            headers: {
            "Content-Type": "multi-part/form-data",
            },
            onUploadProgress: function(progressEvent){
                console.log("--- Upload Progress Initiated ---");
                let percentCompleted = 0;
                // updateProgressMessage(t("upload-study.wait-upload"));
                // updateProgressBar(0);
                updateProgressBarObjs(t("upload-study.wait-upload"), 0);
                if(props.isZip){
                    percentCompleted = (progressEvent.loaded / progressEvent.total) * 100;
                    if(percentCompleted === 100) {
                        // updateProgressMessage(t("upload-study.zip-uploaded"));
                        // updateProgressBar(100);
                        updateProgressBarObjs(t("upload-study.zip-uploaded"), 100);
                    }
                } else {
                    console.log("--- Progress status ----",progressEvent);
                    percentCompleted = (progressEvent.loaded / progressEvent.total) * 100;
                    updateProgressBarObjs(t("upload-study.wait-upload"), 20);
                    console.log("--- Progress percentCompleted ----",percentCompleted);
                    if(percentCompleted === 40) {
                        // setProgressMessage();
                        // updateProgressMessage(t("upload-study.file-uploaded"));
                        // updateProgressBar(40);
                        updateProgressBarObjs(t("upload-study.file-uploaded"), 0);
                    }
                }
            }
            }).then((res)=>{
                console.log("--- Calling Process Api ---");
                let processID = res.data.data.processId;
                let interval = setInterval(()=>{
                    console.log("--- Upload Interval Running ----");
                    studyUploadProcessStatus(processID, interval);
                },1000)
                resetValuesInform();
                if(props.divRef)
                    props.divRef.current.scrollTop = props.divRef.current.scrollHeight;
            })
            .catch((e)=>{
                console.log("err",e?.response?.status === 400);
                if(e?.response?.status === 429){

                    setTimeout(()=>{
                        setProgressObj(()=>{
                            const newItem = {...progressObj};
                            newItem.progress = 0;
                            newItem.progressMessage = t("error.upload-limit-exceeded");
                            return newItem;
                        });
                    },100);
                    setIsError(true);
                    return;
                  }
                if(e?.response?.status === 400){
                    setTimeout(()=>{
                        setProgressObj(()=>{
                            const newItem = {...progressObj};
                            newItem.progress = 0;
                            newItem.progressMessage = e?.response?.data?.message;
                            return newItem;
                        });
                    },100);
                }else{
                    setTimeout(()=>{
                        setProgressObj(()=>{
                            const newItem = {...progressObj};
                            newItem.progress = 0;
                            newItem.progressMessage = t("string-literals.error-msg");
                            return newItem;
                        });
                    },100);
                }
                
                
                setIsError(true);
                if(props.divRef)
                    props.divRef.current.scrollTop = props.divRef.current.scrollHeight;
                // resetValuesInform();
            });
    }

    const resetValuesInform = () => {
        if(props.isJpg){
            if(props.setValues){
                props.setValues({
                    patientName: "",
                    patientId: "",
                    age: "",
                    sex: "",
                    dob: "",
                    accessionNumber: "",
                    clientId: "",
                    files: ""
                });
            }
            if(props.setFilterObj){
                props.setFilterObj({});
                // props.setFilterObj({ ...props.filterObj, sex: null }); 
            }
            props.setSelectedFileName(t("upload-study.no-file-selected"))
        }
    }

    useEffect(()=>{
        const progressBarObject = progressObjs[props.progressBarId];
        if(progressBarObject.uploadStatus == 0){
            uploadDicomApi();
            updateUploadStatus();
            setShowProgressBar(true);
        }else{
            setProgressObj(()=>{
                const newItem = {...progressObj};
                newItem.progress = progressBarObject.progress;
                newItem.progressMessage = progressBarObject.progressMessage;
                return newItem;
            });
            setShowProgressBar(true);
        }
    },[progressObjs]);


    const updateProgressBarObjs = (message, progress) => {
        setProgressObjs((prevProgressObjs) => {
            const updatedProgressObjs = [...prevProgressObjs];
            // const progressBarIndex = updatedProgressObjs.findIndex(obj => obj.progressBarId === props.progressBarId);
            //const progressBarIndex = updatedProgressObjs[props.progressBarId];
            if (props.progressBarId !== -1) {
                updatedProgressObjs[props.progressBarId] = {
                    ...updatedProgressObjs[props.progressBarId],
                    progress : progress,
                    progressMessage: message,
                };
            }
    
            return updatedProgressObjs;
        });
        setProgressObj(()=>{
            const newItem = {...progressObj};
            newItem.progress = progress;
            newItem.progressMessage = message;
            return newItem;
        });
    };

    const updateUploadStatus = () => {
        setProgressObjs((prevProgressObjs) => {
            const updatedProgressObjs = [...prevProgressObjs];
            // const progressBarIndex = updatedProgressObjs.findIndex(obj => obj.progressBarId === progressBarId);
    
            if (props.progressBarId !== -1) {
                updatedProgressObjs[props.progressBarId] = {
                    ...updatedProgressObjs[props.progressBarId],
                    uploadStatus: 1,
                };
            }
    
            return updatedProgressObjs;
        });
    };

	return (
        <>
        { showProgressBar && (<div style={MainDiv}>
            <div style={{display:"flex",flexDirection:"row"}}>
                <div style={Parentdiv}>
                    <div id="progressPercent" style={Childdiv}>
                        <span style={progresstext}></span>
                    </div>                
                </div>
                <span style={fileNameStyle}>{props.fileName}</span>
            </div>
            <span id="progressMessage" className={(isError &&
              progressObj.progressMessage != t("upload-study.zip-uploaded"))?"errorClass":"messageStyle"}>{progressObj.progressMessage}</span>
        </div>)}
    </>
	)
}

export default ProgressBar;
